<template>
    <article
        v-if="item"
        class="post-item"
        :class="['type-' + item.post_type]"
        v-bind="$attrs"
    >
        <router-link :to="link" :id="`${item.title}-page`">
            <figure class="image" v-if="img">
                <img :src="img" />
            </figure>
            <div class="info">
                <p v-if="str" class="meta" v-html="str"></p>
                <h2 class="post-title" v-if="title" v-html="title"></h2>
                <p
                    class="excerpt"
                    v-if="item.post_excerpt"
                    v-html="item.post_excerpt"
                ></p>
                <slot></slot>
            </div>
        </router-link>
    </article>
</template>

<script>
import { format } from "fecha";

export default {
    props: {
        item: {
            type: Object,
            default: false
        }
    },

    data() {
        return {
            img: "",
            title: "",
            link: "",
            str: "",
            id: ""
        };
    },

    mounted() {
        if (this.item.title && this.item.title.rendered) {
            this.title = this.item.title.rendered;
        } else {
            this.title = this.item.post_title;
        }

        this.link = this.item.link.replace(
            window.globals.home_url,
            this.$base_url
        );
        if (this.item.featured_image)
            this.img = this.item.featured_image.medium;

        if (this.item.types && this.item.types.length !== 0) {
            this.str = this.str + this.item.types[0].name + ", ";
        }

        if (this.item.type === "news") {
            let date = this.item.post_date.replace(" ", "T");
            this.str = this.str + format(new Date(date), "DD MMM YYYY");
        }
    }
};
</script>

<style lang="scss" scoped>
.post-item {
    margin: var(--padding) 0;
    box-sizing: border-box;

    a {
        position: relative;
        background: var(--white);
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
    }

    &:hover {
        h2 {
            text-decoration: underline;
        }

        .image img {
            transform: scale(0.95);
        }
    }

    .image {
        width: 46%;
        display: block;
        position: relative;

        &::before {
            content: "";
            display: block;
            padding-bottom: 70%;
        }

        img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            display: block;
            object-fit: cover;
            transition: all 0.2s ease-out;
        }
    }

    .info {
        width: 54%;
        box-sizing: border-box;
        padding-left: var(--padding);
    }

    .meta {
        margin: 0 0 var(--padding);
    }

    .post-title {
        font-size: var(--large-size);
        margin: 0 0 0.5rem;
    }
}
@media only screen and (max-width: 767px) {
    .post-item {
        margin: var(--padding) 0 var(--padding-x3);

        a {
            display: block;
        }

        .image {
            width: 80%;
            margin: auto;

            &::before {
                padding-bottom: 75%;
            }
        }

        .info {
            width: 100%;
            padding-left: 0;
            padding: var(--padding-50) 0;
            text-align: left;
        }

        &.home-item .info {
            text-align: center;
        }

        .meta {
            margin: 0 0 var(--padding);
        }

        .post-title {
            font-size: var(--large-size);
            margin-bottom: 0.5em;
        }

        .excerpt {
            font-size: var(--base-size);
        }
    }
}
</style>
